import { useEffect } from 'react';
import usePlanFeatures from './usePlanFeatures';
import { useHiddenWithTerminal } from './useTerminalTab';
import { hiddenTabNote, isTabHidden } from '../utils/projectTabsModel';

/**
 * The workspace view (utils/workspaceModel.js) kept to the tabs the person's plan shows: a view the plan hides (a link
 * such as `?tab=traces`, the AI, an old bookmark, the `collab:openHistory` event) is closed, so the project Home shows,
 * with a short note (the app's `show-toast`). Also when the plan's answer arrives after the view opened. Terminal too
 * where it is not offered to the person in `projectId` (hooks/useTerminalTab.js), once that is known. Returns the
 * plan's hidden tabs.
 */
export default function usePlanViewGate(view, setView, projectId = null) {
  const { hiddenTabs: planHidden } = usePlanFeatures();
  const hiddenTabs = useHiddenWithTerminal(planHidden, projectId, { pendingHides: false });
  const tab = view?.tab || null;
  useEffect(() => {
    if (!tab || !isTabHidden(hiddenTabs, tab)) { return; }
    setView(null);
    window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: hiddenTabNote(tab), type: 'info' } }));
  }, [tab, hiddenTabs]); // eslint-disable-line react-hooks/exhaustive-deps
  return planHidden;
}
